import { SIZE_UNIT } from '@/constants';
import queryString from 'query-string';

/**
 * 注意： 这个方法只能运行在服务端
 * 注意： 这个方法只能运行在服务端
 * 注意： 这个方法只能运行在服务端
 *
 * 从cookie获取token
 * @returns token
 */
export async function getTokenFromCookie(): Promise<Maybe<string>> {
  const { cookies } = await import('next/headers');
  const fw_cookie = (await cookies()).get('fwat');
  return fw_cookie?.value;
}

/**
 * 计算文件大小
 * @param {number} length 文件字节长度
 */
export function fileSize(length: number) {
  if (!length) {
    return '-';
  }
  if (length > SIZE_UNIT.tb) {
    return (length / SIZE_UNIT.tb).toFixed(2) + ' TB';
  }
  if (length > SIZE_UNIT.gb) {
    return (length / SIZE_UNIT.gb).toFixed(2) + ' GB';
  }
  if (length > SIZE_UNIT.mb) {
    return (length / SIZE_UNIT.mb).toFixed(2) + ' MB';
  }
  return (length / SIZE_UNIT.kb).toFixed(2) + ' KB';
}

/**
 * 获取文件展示地址
 * @param {string} fid 文件标识
 */
export function getImageURL(fid: string) {
  if (!fid) {
    return '/logo/feicheche.jpg';
  }
  if (!!fid && (fid.includes('file:') || fid.includes('content:') || fid.includes('http:') || fid.includes('https:'))) {
    return fid;
  }
  return `${process.env.NEXT_PUBLIC_FILE_HOST}/show?fid=${fid}`;
}

/**
 * @description: 隐藏身份证中间8位
 * @description: 使用后若没有用星号隐藏中间数据，则说明该身份证号位数不对
 * @param {string} idCard
 * @return {string}
 */
export function formatIdCard(idCard: string | undefined): string {
  if (!idCard) return '-';
  if (idCard.length == 18) return idCard.replace(/(^\d{3})\d{11}(\d+)/, '$1***********$2');
  return idCard;
}

/**
 * 电话号码脱敏
 * @param phone 电话号码
 */
export function markPhone(phone?: string) {
  if (!phone) {
    return '';
  }
  return phone.replace(/^(\d{3})\d{4}(\d+)/, '$1****$2');
}

interface WxUriParam {
  page?: string;
  [key: string]: Maybe<string>;
}

/** 生成微信公众号授权地址 */
export function genWxUri(param: WxUriParam = {}): string {
  const redirect_uri = encodeURIComponent(
    queryString.stringifyUrl(
      {
        url: 'https://testportal.feewee.cn',
        query: param,
      },
      { encode: false },
    ),
  );
  const url =
    'https://open.weixin.qq.com/connect/oauth2/authorize?' +
    `appid=${process.env.NEXT_PUBLIC_WXAPPID}&redirect_uri=${redirect_uri}` +
    '&response_type=code&scope=snsapi_userinfo&state=w0&connect_redirect=1#wechat_redirect';
  return url;
}
